import React from 'react';

const GuarantiesDepartmentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34.629" height="34.771" viewBox="0 0 34.629 34.771">
    <path id="Path_2842" dataname="Path 2842" d="M4236.235,4454.125a1.436,1.436,0,0,0-1.448.345l-3.519,3.464-3.08-1.03a1.376,1.376,0,0,1-.863-.869l-1.025-3.09,3.449-3.535a1.456,1.456,0,0,0,.343-1.456,1.439,1.439,0,0,0-1.121-.984,9.892,9.892,0,0,0-8.841,2.813,10.114,10.114,0,0,0-2.274,10.822l-13.552,11.872a5.32,5.32,0,1,0,7.578,7.468l11.716-13.55a10.1,10.1,0,0,0,13.618-11.144A1.443,1.443,0,0,0,4236.235,4454.125Z" transform="translate(-4202.746 -4446.812)" fill="#2a3588"/>
  </svg>
);

export default GuarantiesDepartmentIcon;
